import { createSelector } from 'reselect'
import { digObject } from 'functions/utilities'

const defaultFilter = (entitiesArray, filterField, permittedValueArray) => entitiesArray.filter((entity) => {
  const fieldValue = digObject(entity, filterField, null)

  return permittedValueArray.includes(fieldValue)
})

const arrayFilter = (entitiesArray, filterField, permittedValueArray) => entitiesArray.filter((entity) => {
  const fieldValue = digObject(entity, filterField, [])

  return permittedValueArray.some(p => fieldValue.indexOf(p) !== -1)
})

const getFilteredEntities = (state, entityKey, filterField, permittedValues = [], options = {}) => {
  const { arrayFilterField } = options
  const entities = state.entities[entityKey]
  const entitiesArray = Object.values(entities)
  const permittedValueArray = Array.isArray(permittedValues) ? permittedValues : [permittedValues]

  if (arrayFilterField){
    return arrayFilter(entitiesArray, filterField, permittedValueArray)
  }

  return defaultFilter(entitiesArray, filterField, permittedValueArray)
}

const filteredObjectArraySelector = createSelector(
  [getFilteredEntities],
  entities => entities,
)

export default filteredObjectArraySelector
